import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useState, useEffect } from "react";
import classnames from "classnames";
import styles from "@/styles/Loading.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";

var IconSpiner = function IconSpiner(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "#09F",
      d: "M24 44c2 0 3.9-.2 5.8-.7 1.9-.6 3.7-1.4 5.4-2.4 1.7-1.1 3.2-2.4 4.5-3.9 1.3-1.5 2.4-3.2 3.2-5.1.8-1.8 1.3-3.8 1.6-5.8.2-2 .2-4.1-.2-6.1s-1-4-1.9-5.8c-1-1.8-2.2-3.5-3.6-5-1.5-1.5-3.1-2.7-4.9-3.8-1.8-1-3.8-1.7-5.8-2.2-2-.4-4.1-.6-6.2-.4-2.1.2-4.2.6-6.1 1.4-2 .8-3.8 1.8-5.5 3.1-1.6 1.3-3.1 2.9-4.4 4.6-1.2 1.8-2.2 3.7-2.8 5.7-.7 2-1 4.2-1.1 6.3 0-2.2.2-4.3.8-6.4.6-2.1 1.5-4.1 2.7-5.9 1.2-1.8 2.7-3.5 4.3-4.9 1.7-1.4 3.6-2.6 5.6-3.5 2-.9 4.2-1.4 6.4-1.7 2.2-.2 4.4-.2 6.7.2 2.2.4 4.3 1.1 6.3 2.1s3.8 2.4 5.5 3.9c1.6 1.6 3 3.4 4.1 5.4 1.1 2 1.9 4.1 2.4 6.4.5 2.2.6 4.5.5 6.8-.2 2.3-.7 4.5-1.5 6.7-.9 2.1-2 4.2-3.4 6-1.5 1.8-3.2 3.4-5.1 4.8-1.9 1.3-4 2.3-6.3 3.1-2.2.7-4.6 1.1-6.9 1.2-1.1 0-2-.8-2.1-1.9s.8-2 1.9-2.1c0-.1 0-.1.1-.1z"
    })
  }));
};

IconSpiner.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  xmlSpace: "preserve"
}; // showStartにミリ秒を指定すると表示開始を遅らせることができる。
// 一瞬だけローディングがでて微妙という場合に使う想定

export default function Loading(_ref) {
  var fixed = _ref.fixed,
      showStart = _ref.showStart;

  var _useState = useState(showStart ? false : true),
      show = _useState[0],
      setShow = _useState[1];

  useEffect(function () {
    var timeoutId;

    if (showStart) {
      timeoutId = setTimeout(function () {
        return setShow(true);
      }, showStart);
    }

    return function () {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
  if (!show) return null;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.wrapper, _defineProperty({}, styles.fixed, fixed)),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.loaderCont,
      children: /*#__PURE__*/_jsx(IconSpiner, {})
    })
  });
}